<template>
  <div>
    <va-modal
      :value="showModal"
      id="referenceValuesModal"
      ref="referenceValuesModal"
      size="large"
      :showOkay="false"
      @cancel="$emit('cancel')"
      :cancelText="$t('leads.back')"
      :noDismiss="true"
      :no-outside-dismiss="false"
      :fixedLayout="true">
      <div slot="header" class="modal-title d-flex justify--space-between pb-0 mb-0">
        <span>{{$t('checkup_plus.reports.measurements.measurement_reference_values', {measurement: $t(`dashboard_new_evollu.parameters.${addUnderscoreToUppercase(referenceValues.measurementType)}`)})}}</span>
      </div>

      <div v-for="refValue in referenceValues">
        <h5 class="is-bold" style="color: #545454">
          {{$t(`dashboard_new_evollu.parameters.graphs.titles.${refValue.groupChart.replace('GROUP_CHART_', '').toLowerCase()}`)}}
        </h5>
        <table class="mb-3 mt-1 w-100">
          <tr>
            <th v-for="(elem, idx) in refValue.referenceTableHeaders">
              <span v-if="idx===0">
                {{$t('checkup_plus.reference_values.report_table_header_condition')}}
              </span>
              <span v-else>
                {{$t(`dashboard_new_evollu.measurement_types.${elem.replace('REPORT_EMAIL_', '').toLowerCase()}_short`)}}
              </span>

            </th>
          </tr>
          <tr v-for="row in refValue.tableRows">
            <td v-for="(val, idx) in row">
              <span v-if="idx === 0">
                {{$t(`dashboard_new_evollu.parameters.graphs.legends.${val.toLowerCase()}`)}}
              </span>
              <span v-else>
                {{ translateCriteriaWithI18n(val) }}
              </span>
            </td>
          </tr>
        </table>
        <div v-if="refValue.referencesLink" class="row pl-2">
          <span> {{$t('patients.inputs.source')}}:&ensp;<a :href="refValue.referencesLink">{{refValue.visibleLink ? refValue.visibleLink : refValue.referencesLink}}</a></span>
        </div>
      </div>

    </va-modal>
  </div>

</template>

<script>
export default {
  props: {
    referenceValues: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      showModal: false,
    };
  },
  mounted() {
    this.showModal = true
  },
  methods: {
    addUnderscoreToUppercase: function (inputString) {
      var modifiedString = "";

      for (var i = 0; i < inputString.length; i++) {
        var currentChar = inputString.charAt(i);

        if (currentChar === currentChar.toUpperCase() && /[A-Z]/.test(currentChar)) {
          // If the character is uppercase, add an underscore and the lowercase version
          modifiedString += "_" + currentChar.toLowerCase();
        } else {
          // If the character is not uppercase, keep it as is
          modifiedString += currentChar;
        }
      }

      return modifiedString;
    },
    parseCriteriaString: function (data) {

      if(data.criteriaList === null || data.criteriaList.length === 0) return "N/A"
      const translatedOperator = this.$t(`biosigns.operators.${data.operator.toLowerCase()}`)
      let parsedStr = ""

      data.criteriaList.forEach((elem, idx) => {
        if(idx > 0) {
          parsedStr+=` ${translatedOperator} `
        }
        parsedStr+=this.$t(`dashboard_new_evollu.measurement_types.${elem.attributeName.toLowerCase().replaceAll(' ', '_')}_short`)
        parsedStr+=` ${elem.criteria}`
        if(elem.units) {
          parsedStr+=` ${elem.units}`
        }
      })

      return parsedStr
    },
    translateCriteriaWithI18n(text) {
      return text.replace(/\b[A-Z0-9_]+\b/g, (match) => {
        const key = `dashboard_new_evollu.measurement_types.${match.toLowerCase()}_short`;
        const translated = this.$t(key);
        return translated === key ? match : translated; // fallback to original if no translation found
      });
    }
  },
};
</script>

<style scoped lang="scss">
table {
  border-collapse: separate;
  border-spacing: 0;
}

th, td {
  border: 1px solid #b4b4b4;
  padding: 5px 10px;
}

th {
  font-weight: bold;
  background-color: #d5d5d5;
}

th:first-child {
  border-top-left-radius: 8px;
}

th:last-child {
  border-top-right-radius: 8px;
}

tr:last-child td:first-child {
  border-bottom-left-radius: 8px;
}

tr:last-child td:last-child {
  border-bottom-right-radius: 8px;
}

</style>
